import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { doc, docData, Firestore, updateDoc } from '@angular/fire/firestore';
import { Shoutout, shoutoutConverter } from 'src/app/models/shoutout.model';

@Injectable()
export class ShoutoutStoreService {
  private _firestore = inject(Firestore);
  private _shoutout: WritableSignal<Shoutout | undefined> = signal<
    Shoutout | undefined
  >(undefined);
  shoutout = this._shoutout.asReadonly();

  getById(id: string) {
    const shoutoutRef = doc(this._firestore, `shoutouts/${id}`).withConverter(
      shoutoutConverter,
    );
    docData(shoutoutRef, {
      idField: 'id',
    }).subscribe((shoutout) => {
      this._shoutout.set(shoutout);
    });
  }

  update(shoutout: Shoutout) {
    if (!shoutout?.id) {
      throw new Error('Shoutout ID is required for update.');
    }
    const shoutoutRef = doc(
      this._firestore,
      `shoutouts/${shoutout.id}`,
    ).withConverter(shoutoutConverter);
    const { id, ...updateData } = shoutout;
    updateDoc(shoutoutRef, updateData);
  }
}
